import {useNavigate } from 'react-router-dom';
import { signOutRedirect } from '../../auth/cognitoLogout';
import { FaCalendarAlt, FaBriefcase, FaSignOutAlt, FaCloud } from 'react-icons/fa';
import styles from './adminEvents.module.scss';

const AdminHomePage = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.adminPage}>
            <div className={styles.adminContent}>
                <div className={styles.container}>
                    <div className={styles.adminHeader}>
                        <h1>Admin Portal</h1>
                        <button onClick={signOutRedirect} className={styles.logoutBtn}>
                            <FaSignOutAlt /> Logout
                        </button>
                    </div>

                    <div className={styles.formCard}>
                        <h2>Choose table to be updated</h2>
                        <div className={styles.formActions}>
                            <button
                                type="button"
                                className={styles.submitBtn}
                                onClick={() => navigate('/admin/events')}
                            >
                                <FaCalendarAlt /> Event Management
                            </button>

                            <button
                                type="button"
                                className={styles.submitBtn}
                                onClick={() => navigate('/admin/jobs')}
                            >
                                <FaBriefcase /> Job Listings Management
                            </button>

                            <button
                                type="button"
                                className={styles.submitBtn}
                                onClick={() => navigate('/admin/insights')}
                            >
                                <FaCloud /> Insights Management
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminHomePage;